/** Field Duty expense defaults (parity with mobile `expense_config.dart`). */

export const DEFAULT_EXPENSE_HOME_RADIUS_KM = 25;
export const DEFAULT_EXPENSE_TRAVEL_RATE_PER_KM = 10;
export const DEFAULT_EXPENSE_POST_DUTY_WINDOW_HOURS = 24;
export const MAX_EXPENSE_RECEIPTS = 3;

const PIN_PATTERN = /^\d{6}$/;

export function clampExpenseHomeRadiusKm(value: number | undefined): number {
  if (value == null || !Number.isFinite(value)) {
    return DEFAULT_EXPENSE_HOME_RADIUS_KM;
  }
  // 0 = manual expenses only (no radius latch / no auto travel).
  if (value === 0) return 0;
  if (value < 0) return DEFAULT_EXPENSE_HOME_RADIUS_KM;
  return Math.min(500, Math.max(1, value));
}

/** Owner set radius to 0: members can add manual expenses without leaving home. */
export function isManualOnlyExpenseMode(expenseHomeRadiusKm: number): boolean {
  return expenseHomeRadiusKm === 0;
}

export function clampExpenseTravelRatePerKm(value: number | undefined): number {
  if (value == null || !Number.isFinite(value) || value < 0) {
    return DEFAULT_EXPENSE_TRAVEL_RATE_PER_KM;
  }
  return Math.min(1000, Math.max(0, value));
}

export function clampExpensePostDutyWindowHours(value: number | undefined): number {
  if (value == null || value <= 0) return DEFAULT_EXPENSE_POST_DUTY_WINDOW_HOURS;
  return Math.min(168, Math.max(1, Math.floor(value)));
}

export function normalizeIndianPinCode(raw: string): string {
  return raw.trim();
}

export function isValidIndianPinCode(raw: string): boolean {
  return PIN_PATTERN.test(normalizeIndianPinCode(raw));
}

export function travelExpenseAmountInr(params: {
  distanceMeters: number;
  ratePerKm: number;
}): number {
  const { distanceMeters, ratePerKm } = params;
  if (!Number.isFinite(distanceMeters) || distanceMeters <= 0) return 0;
  if (!Number.isFinite(ratePerKm) || ratePerKm <= 0) return 0;
  const amount = (distanceMeters / 1000) * ratePerKm;
  return Number.isFinite(amount) ? Math.round(amount * 100) / 100 : 0;
}
